import { AutoMap } from "@automapper/classes";

export class MeasureLingetteDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    samplingTime!: string;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    samplingId!: number;
    @AutoMap()
    typeSurface!: string;
    @AutoMap()
    referenceLot!: string;
    @AutoMap()
    temoin!: string;
    @AutoMap()
    visibilitePoussiere!: boolean;
    @AutoMap()
    surfacePrelevement!: number;
    @AutoMap()
    contexte!: number;
    @AutoMap()
    apresNettoyage!: boolean;
    @AutoMap()
    sampleCode?: string;
}